import { render, staticRenderFns } from "./PrintMenuPrinter.vue?vue&type=template&id=0fa29d0f&scoped=true&"
import script from "./PrintMenuPrinter.vue?vue&type=script&lang=js&"
export * from "./PrintMenuPrinter.vue?vue&type=script&lang=js&"
import style0 from "./PrintMenuPrinter.vue?vue&type=style&index=0&id=0fa29d0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa29d0f",
  null
  
)

export default component.exports